import React from 'react';
import './styles.css';
import { Opacity_16 } from "../../../utils/colors";
export default function Fab(_ref) {
  var theme = _ref.theme,
      onClick = _ref.onClick,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'small' : _ref$size,
      _ref$isIconEnabled = _ref.isIconEnabled,
      isIconEnabled = _ref$isIconEnabled === void 0 ? false : _ref$isIconEnabled,
      _ref$icon = _ref.icon,
      icon = _ref$icon === void 0 ? null : _ref$icon;

  var styles = function styles() {
    if (isIconEnabled === null) {
      return {
        backgroundColor: Opacity_16,
        borderColor: '#565656'
      };
    }

    return {
      backgroundColor: !isIconEnabled ? theme.userDefined.ctrlButtonColor : 'transparent',
      borderColor: !isIconEnabled ? theme.userDefined.ctrlButtonColor : '#565656'
    };
  };

  var fabStateStyles = isIconEnabled !== null ? isIconEnabled ? 'fab--enabled' : 'fab--disabled' : '';
  var fabCursorStyles = disabled ? 'fab__cursor--disabled' : 'fab__cursor--enabled';
  return /*#__PURE__*/React.createElement("button", {
    className: "button-base--root fab--root fab--small fab " + fabStateStyles + " " + fabCursorStyles,
    onClick: onClick,
    style: styles(),
    disabled: disabled,
    size: size
  }, /*#__PURE__*/React.createElement("span", {
    className: "fab__label"
  }, icon));
}